// extracted by mini-css-extract-plugin
module.exports = {"box":"SMEPurposes_box__2X65Q","content":"SMEPurposes_content__1qQVj"};